/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { getPolicyLanguageQuerySchema } from "../getPolicyLanguageQuerySchema.ts";
import { policyLanguageModelSchema } from "../policyLanguageModelSchema.ts";
import { z } from "zod";

export const getApiPolicyLanguageQueryParamsSchema = z.object({
    "query": z.lazy(() => getPolicyLanguageQuerySchema).describe("Модель запроса").optional()
    }).optional()

/**
 * @description Языки для политики
 */
export const getApiPolicyLanguage200Schema = z.lazy(() => policyLanguageModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiPolicyLanguage400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiPolicyLanguage401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiPolicyLanguage403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Языков для политики нет
 */
export const getApiPolicyLanguage404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiPolicyLanguage500Schema = z.lazy(() => badResponseModelSchema)

export const getApiPolicyLanguageQueryResponseSchema = z.lazy(() => getApiPolicyLanguage200Schema)